import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'edl-send-notification-modal',
    templateUrl: './edl-send-notification-modal.component.html',
    styleUrls: ['./edl-send-notification-modal.component.scss']
})
export class EdlSendNotificationModal {
    @Input() title?: string = '';
    @Input() message?: string = '';
    @Input() yesButtonText?: string;
    @Input() noButtonText?: string;

    additionalText: string = '';

    constructor(public activeModal: NgbActiveModal) {}
}